import { render, staticRenderFns } from "./FilterDepartmentData.vue?vue&type=template&id=36e79fc0&scoped=true"
import script from "./FilterDepartmentData.vue?vue&type=script&lang=js"
export * from "./FilterDepartmentData.vue?vue&type=script&lang=js"
import style0 from "./FilterDepartmentData.vue?vue&type=style&index=0&id=36e79fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e79fc0",
  null
  
)

export default component.exports